(function (DGS) {
  DGS.OnLoad.getInstance().register(function () {
    function addLinksToSocialMediaFromBlogSubscriptionForm() {
      var socialMediaContainer = $('.form.blog-subscription-form .social-media-container');
      var currentUrl = window.location.href;
      if (socialMediaContainer.length) {
        var links = socialMediaContainer.find($('.news-social-media-item'));
        links.each(function () {
          var socialHref = $(this).attr('href');
          var newHref = socialHref + currentUrl;
          $(this).attr('href', newHref);
        });
      }
    }
    function addPlaceholderToBlogSubscriptionForm() {
      var form = $('.component.form.blog-subscription-form');
      var label = form.find($('.scfEmailLabel'));
      var input = label.next('.scfEmailGeneralPanel').find('input[type=text]');
      if (label.length) {
        input[0].placeholder = label[0].innerText;
      }
    }
    function markBlogSubscriptionFormContainer() {
      var mainContainers = $('.component.form.blog-subscription-form').find('.scfForm > div');
      mainContainers.each(function () {
        if ($(this).find('.scfEmailTextBox').length) {
          $(this).addClass('blog-subscription-form-container');
        }
      });
    }
    function handleBlogSubscriptionForm() {
      addLinksToSocialMediaFromBlogSubscriptionForm();
      addPlaceholderToBlogSubscriptionForm();
      markBlogSubscriptionFormContainer();
    }
    handleBlogSubscriptionForm();
  });
})(window.DGS);